import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import "./MusicSchedules.css";
import { useTranslation } from "react-i18next";
import MusicScheduleSongs from "./MusicScheduleSongs";

const MusicScheduleSongsModal = ({
  musicScheduleId,
  musicScheduleData,
  onDeleteSongs,
  openModal,
  setOpenModal,
  showPlayer = true,
  ...props
}: {
  musicScheduleId: number;
  musicScheduleData?: any;
  onDeleteSongs?: Function;
  openModal: boolean;
  setOpenModal: Function;
  showPlayer?: boolean;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("MUSIC_SCHEDULE")} {t("SONGS")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <MusicScheduleSongs
              withHeader={false}
              musicScheduleId={musicScheduleId}
              onDeleteSongs={onDeleteSongs}
              enableBulkAction={["delete"]}
              showPlayer={showPlayer}
            />
            <ButtonToolbar className="btn-center">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MusicScheduleSongsModal;
